// src/components/shared/KpiRow.jsx
import { LABELS } from "../../utils/tiempos";

function KpiItem({ label, value, highlight = false }) {
  const baseItem = "px-3 py-2 flex flex-col gap-0.5 min-w-[96px]";
  const baseLabel = "text-[10px] uppercase tracking-wide";
  const baseValue = "text-sm font-semibold";
  const itemClass = highlight ? `${baseItem} bg-emerald-50/80` : baseItem;
  const labelClass = highlight ? `${baseLabel} text-emerald-600` : `${baseLabel} text-slate-500`;
  const valueClass = highlight ? `${baseValue} text-emerald-700` : `${baseValue} text-slate-800`;

  return (
    <div className={itemClass}>
      <span className={labelClass}>{label}</span>
      <span className={valueClass}>{value}</span>
    </div>
  );
}

export default function KpiRow({ jornada, descanso, efectivo, className = "" }) {
  return (
    <div
      className={`inline-flex flex-wrap divide-x divide-slate-200 overflow-hidden rounded-xl border border-slate-200 bg-white/70 shadow-sm ${className}`}
    >
      <KpiItem label={LABELS.JORNADA} value={jornada} />
      <KpiItem label={LABELS.DESCANSO} value={descanso} />
      <KpiItem label={LABELS.EFECTIVO} value={efectivo} highlight />
    </div>
  );
}
